exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * Foundation for Sites by ZURB\n * Version 6.4.1\n * foundation.zurb.com\n * Licensed under MIT Open Source\n */\na {\n  color: #18222c;\n  padding: 0.7rem 1rem;\n  font-size: 0.875rem; }\n  a .fa {\n    width: 24px;\n    font-size: 0.875rem; }\n\n.logo {\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);\n  padding: 0.7rem 1rem;\n  background-color: #324595; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/off-canvas-menu/off-canvas-menu.component.scss
// module id = 188
// module chunks = 1